<template>
  <div class="TotalAmountContainer" :class="{ invisible: project === 'elite' }">
    <div v-if="hasDeposit" class="TotalAmountContainer-DepositWrapper">
      <div class="TotalAmountContainer-Item TotalAmountContainer-SubtotalPrice">
        {{ $t("order.subtotal_amount") }}
        {{ basket.vatDetails.grossPaid.toPrintable() }}
      </div>
      <div class="TotalAmountContainer-Item TotalAmountContainer-Deposit">
        {{ $t("order.deposit") }}
        {{ basket.vatDetails.depositPaid.toPrintable() }}
      </div>
    </div>
    <div class="TotalAmountContainer-Item TotalAmountContainer-Text">
      {{ $t("order.total_amount") }}
    </div>
    <div class="TotalAmountContainer-Item TotalAmountContainer-Price">
      {{ basket.vatDetails.absoluteTotal.toPrintable() }}
    </div>
  </div>
</template>

<script>
import {
  subtotalPrice,
  totalDeposit,
  totalDepositRaw,
  totalPrice
} from "@/utils/pricing";
import { mapGetters } from "vuex";

export default {
  name: "TotalAmount",
  computed: {
    hasDeposit() {
      return totalDepositRaw(this.basket, true, this.coupons) > 0;
    },
    sumDeposit() {
      return totalDeposit(this.basket, true, this.coupons);
    },
    sumSubtotalPrice() {
      return subtotalPrice(this.basket, true, this.coupons);
    },
    sumPrice() {
      return totalPrice(this.basket, true, this.coupons);
    },
    ...mapGetters({
      basket: "BASKET",
      project: "PROJECT",
      coupons: "COUPONS",
      language_code: "LANGUAGE_CODE",
      locale_code: "LOCALE_CODE",
      currency_code: "CURRENCY_CODE"
    })
  }
};
</script>

<style lang="scss" scoped>
.invisible {
  opacity: 0;
}
.TotalAmountContainer {
  color: var(--component_TotalAmount_TotalAmountContainer_color);
  display: flex;
  flex-direction: column;
  font-family: var(--component_TotalAmount_TotalAmountContainer_font-family);
  font-size: var(--component_TotalAmount_TotalAmountContainer_font-size);
  &-DepositWrapper {
    margin-bottom: 20px;
  }
  &-Item {
    text-align: center;
  }
  &-Deposit {
    font-size: var(
      --component_TotalAmount_TotalAmountContainer-Deposit_font-size
    );
    font-family: var(
      --component_TotalAmount_TotalAmountContainer-Deposit_font-family
    );
    font-weight: normal;
  }
  &-SubtotalPrice {
    font-size: var(
      --component_TotalAmount_TotalAmountContainer-SubtotalPrice_font-size
    );
    font-family: var(
      --component_TotalAmount_TotalAmountContainer-SubtotalPrice_font-family
    );
    font-weight: normal;
  }
  &-Text {
    font-family: var(
      --component_TotalAmount_TotalAmountContainer-Text_font-family
    );
    font-size: var(--component_TotalAmount_TotalAmountContainer-Text_font-size);
    font-weight: var(
      --component_TotalAmount_TotalAmountContainer-Text_font-weight
    );
  }
  &-Price {
    font-family: var(
      --component_TotalAmount_TotalAmountContainer-Price_font-family
    );
    font-size: var(
      --component_TotalAmount_TotalAmountContainer-Price_font-size
    );
    font-weight: var(
      --component_TotalAmount_TotalAmountContainer-Price_font-weight
    );
    letter-spacing: 3px;
  }
}
</style>
